import React from 'react'
import $console from '@zuto/utilities/src/$console'
import ZutoAnalyticsHelper from '@zuto-internal/zuto-analytics-helper'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import { styled, Typography } from '@mui/material'
import { muiColors } from '@zuto/theme/src/mui/DefaultTheme'
import { fireReactGAEvent } from '../../../../src/components/Questions/utils'

type RequiredInfoProps = {
  experimentName: string
  testId?: string
  text?: string
  onClickHandler?: React.MouseEventHandler<HTMLDivElement>
  clickable?: boolean
}

const Required = styled('div')({
  display: 'flex',
  p: {
    margin: 0,
    color: muiColors.primary.errorRedMain
  },
  svg: {
    marginRight: '5px',
    color: muiColors.primary.errorRedMain
  },
  '&.is-clickable': {
    cursor: 'pointer'
  }
})

export const RequiredInfo = ({
  experimentName, testId, text, onClickHandler, clickable = false
}: RequiredInfoProps): JSX.Element => {
  const zutoAnalyticsHelper = new ZutoAnalyticsHelper()

  const handleRequiredInfoClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    try {
      zutoAnalyticsHelper.sendCustomEvent({
        eventType: 'Prefill Review Page - Required Clicked',
        eventCategory: 'Prefill',
        eventAction: `Required Clicked - ${testId}`,
        experiment: experimentName
      })
      fireReactGAEvent({
        category: 'Application Form',
        action: 'Edit Section',
        label: `Required Clicked - ${testId}`,
        nonInteraction: false
      })
      // Check if a custom click handler function (onClickHandler) is provided as a prop.
      // If provided, execute the function (that's been passed as a prop) when the 'Required' element is clicked,
      // pass the event object as an argument.
      if (onClickHandler) onClickHandler(event)
    } catch (error) {
      $console.error('zutoAnalyticsHelper.sendCustomEvent error', error)
    }
  }

  return (
    <Required
      data-testid={testId}
      id={testId}
      onClick={handleRequiredInfoClick}
      sx={{ mb: text === 'Incomplete' ? '5px' : '' }}
      className={clickable ? 'is-clickable' : ''}
    >
      <WarningAmberIcon /> <Typography variant="rowHeading">{text || 'Required'}</Typography>
    </Required>
  )
}
